module.exports = __webpack_public_path__ + "img/parallax-one.7acfc98.webp";